import SetTimeProfileServiceRequest from '../data/schema/SetTimeProfileServiceRequest';
import { makePostRequest } from 'owa-ows-gateway';
import getTimeProfileRestEndpoint from '../utils/getTimeProfileRestEndpoint';
import { trace } from 'owa-trace';
import { createRestApiRequestHeadersWithFetchOptions } from 'owa-headers';

export default function setTimeProfileService(setTimeProfileRequest: SetTimeProfileServiceRequest) {
    return makePostRequest(
        getTimeProfileRestEndpoint('setTimeProfile'),
        setTimeProfileRequest /* requestObject */,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        createRestApiRequestHeadersWithFetchOptions() /* customheaders */
    )
        .then(async (response: any) => {
            return response;
        })
        .catch((error: any) => {
            trace.error(error);
            return error;
        });
}
